const LS_PREFIX = 'mdv-recent-layers';
const MAX_RECENT = 50;

function storageKey(projectName) {
  return `${LS_PREFIX}:${String(projectName || 'default')}`;
}

export function readRecentLayers(projectName) {
  try {
    const raw = localStorage.getItem(storageKey(projectName));
    if (!raw) return [];
    const data = JSON.parse(raw);
    if (!Array.isArray(data)) return [];
    return data.filter((k) => typeof k === 'string' && k.length > 0);
  } catch {
    return [];
  }
}

export function writeRecentLayers(projectName, keys) {
  try {
    localStorage.setItem(storageKey(projectName), JSON.stringify(keys.slice(0, MAX_RECENT)));
  } catch {
    // ignore
  }
}

/** Move layer to front of recent list; returns updated array. */
export function recordRecentLayer(projectName, layerKey, currentKeys) {
  if (!layerKey) return currentKeys || readRecentLayers(projectName);
  const base = currentKeys || readRecentLayers(projectName);
  const next = [layerKey, ...base.filter((k) => k !== layerKey)].slice(0, MAX_RECENT);
  writeRecentLayers(projectName, next);
  return next;
}
